import { render, staticRenderFns } from "./KioskPage.vue?vue&type=template&id=7ceef0de"
import script from "./KioskPage.vue?vue&type=script&lang=js"
export * from "./KioskPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports